var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"#linkedin .cls-1{fill:currentColor;}")),React.createElement("path",{"className":"cls-1","d":"M33.2,0H2.6A2.65,2.65,0,0,0,0,2.6V33.4A2.65,2.65,0,0,0,2.6,36H33.2a2.65,2.65,0,0,0,2.6-2.6V2.6A2.41,2.41,0,0,0,33.2,0ZM10.6,30.6H5.2V13.4h5.4ZM8.2,11.2A3,3,0,0,1,5.2,8C4.8,6.4,6.2,5,8,5a3.12,3.12,0,0,1,3.2,3A3.26,3.26,0,0,1,8.2,11.2ZM30.6,30.6H25.2V22.2c0-2,0-4.6-2.8-4.6s-3.2,2.2-3.2,4.4v8.6H13.8L14,13.4h5.2v2.4a5.7,5.7,0,0,1,5-2.8c5.4,0,6.4,3.6,6.4,8.2v9.4Z","key":1})]);
}

Linkedin.defaultProps = {"id":"linkedin","data-name":"Layer 1","viewBox":"0 0 35.82 36"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
